import Container, { Service } from "typedi";
import { TRON_FULL_HOST } from "../constants/config";
import { TronHostSelectorService } from "./TronHostSelectorService";
import { TronService } from "./TronService";

function createTronManagerService() {
  return new TronManagerService(Container.get(TronHostSelectorService));
}

@Service({ factory: createTronManagerService })
export class TronManagerService {
  private tronHostSelectorService: TronHostSelectorService;
  private tronService: TronService;

  constructor(tronHostSelectorService: TronHostSelectorService) {
    this.tronHostSelectorService = tronHostSelectorService;
    this.updateTronService();
  }

  getTronService() {
    return this.tronService;
  }

  updateTronService() {
    this.tronService = new TronService(
      TRON_FULL_HOST,
      this.tronHostSelectorService.getNextFullNode(),
      this.tronHostSelectorService.getSolidityNode()
    );

    return this.tronService;
  }
}
